export const DATADOG_ACTIONS = {
  errors: {
    template_error: 'template_error',
  },
  success: {
    template_success: 'template_success',
  },
  lifecycle: {
    session_init: 'session_init',
  },
  timings: {
    // View-relative custom timings (datadogRum.addTiming) → @view.custom_timings.*
    activation_submitted: 'activation_submitted',
    activation_succeeded: 'activation_succeeded',
    transfer_submitted: 'transfer_submitted',
    transfer_succeeded: 'transfer_succeeded',
    action_submitted: 'action_submitted',
    action_succeeded: 'action_succeeded',
    vowifi_submitted: 'vowifi_submitted',
    vowifi_succeeded: 'vowifi_succeeded',
  },
  esim_transfer: {
    decline_button_clicked: 'esim_transfer_decline_button_clicked',
    approve_button_clicked: 'esim_transfer_approve_button_clicked',
  },
  vowifi: {
    // splash
    vowifi_initial_screen_continue_button_clicked:
      'vowifi_initial_screen_continue_button_clicked',
    // terms and conditions
    terms_accept_button_clicked: 'vowifi_terms_accept_button_clicked',
    terms_decline_button_clicked: 'vowifi_terms_decline_button_clicked',
    // Address
    address_submit_button_clicked: 'vowifi_address_submit_button_clicked',
    address_place_selected: 'vowifi_address_place_selected',
    // Address validation (Google) — suggested-address screen
    address_validation_suggested: 'vowifi_address_validation_suggested',
    suggestion_use_selected_clicked: 'vowifi_suggestion_use_selected_clicked',
    suggestion_use_as_entered_clicked:
      'vowifi_suggestion_use_as_entered_clicked',
    suggestion_edit_address_clicked: 'vowifi_suggestion_edit_address_clicked',
    // Address validation (Google) — unverified-address screen
    address_validation_unconfirmed: 'vowifi_address_validation_unconfirmed',
    unverified_use_anyway_clicked: 'vowifi_unverified_use_anyway_clicked',
    unverified_edit_address_clicked: 'vowifi_unverified_edit_address_clicked',
    // Confirmation
    confirmation_confirm_button_clicked:
      'vowifi_confirmation_confirm_button_clicked',
    confirmation_edit_address_button_clicked:
      'vowifi_confirmation_edit_address_button_clicked',
    confirmation_done_button_clicked: 'vowifi_confirmation_done_button_clicked',
    confirmation_close_button_clicked:
      'vowifi_confirmation_close_button_clicked',
    confirmation_cancel_button_clicked:
      'vowifi_confirmation_cancel_button_clicked',
    confirmation_success: 'vowifi_confirmation_success',
    success_screen_shown: 'vowifi_success_screen_shown',
    step_viewed: 'vowifi_step_viewed',
  },
  watch_activation: {
    open_terms_and_conditions_clicked:
      'watch_activation_open_terms_and_conditions_clicked',
    close_terms_and_conditions: 'watch_activation_close_terms_and_conditions',
    plan_selected: 'watch_activation_plan_selected',
    submit_button_clicked: 'watch_activation_submit_button_clicked',
    submit_error: 'watch_activation_submit_error',
    submit_success: 'watch_activation_submit_success',

    contract_summary_opened: 'watch_activation_contract_summary_opened',
    contract_summary_closed: 'watch_activation_contract_summary_closed',
    contract_summary_submitted: 'watch_activation_contract_summary_submitted',
    feedback_section_closed: 'watch_activation_feedback_section_closed',
    error_message_closed: 'watch_activation_error_message_closed',
    load_plans_error: 'watch_activation_load_plans_error',
    success_screen_shown: 'watch_activation_success_screen_shown',
    notification_shown: 'watch_activation_notification_shown',
  },
  watch_transfer: {
    open_terms_and_conditions_clicked:
      'watch_transfer_open_terms_and_conditions_clicked',
    terms_and_conditions_closed: 'watch_transfer_terms_and_conditions_closed',
    submit_button_clicked: 'watch_transfer_submit_button_clicked',
    submit_success: 'watch_transfer_submit_success',
    error_message_closed: 'watch_transfer_error_message_closed',
    feedback_section_closed: 'watch_transfer_feedback_section_closed',
    success_screen_shown: 'watch_transfer_success_screen_shown',
  },
  watch_manage: {
    action_suspend_clicked: 'watch_manage_action_suspend_clicked',
    action_reactivate_clicked: 'watch_manage_action_reactivate_clicked',
    action_cancel_clicked: 'watch_manage_action_cancel_clicked',
    action_success: 'watch_manage_action_success',
    cancel_confirmation_yes_clicked:
      'watch_manage_cancel_confirmation_yes_clicked',
    cancel_confirmation_no_clicked:
      'watch_manage_cancel_confirmation_no_clicked',
    close_action_feedback_clicked: 'watch_manage_close_action_feedback_clicked',
    close_actions_view_clicked: 'watch_manage_close_actions_view_clicked',
    close_error_clicked: 'watch_manage_close_error_clicked',
    terms_and_conditions_opened: 'watch_manage_terms_and_conditions_opened',
    terms_and_conditions_closed: 'watch_manage_terms_and_conditions_closed',
    success_screen_shown: 'watch_manage_success_screen_shown',
  },
  websheet: {
    localisation_not_found: 'localisation_not_found',
  },
} as const;

export const DATADOG_CALLBACKS_ACTIONS = {
  // Error / state
  invoking_callback_controller_not_found:
    'invoking_callback_controller_not_found',

  // Native SDK methods (Android + iOS)
  invoking_callback_profileReadyWithDefaultSmdp:
    'invoking_callback_profileReadyWithDefaultSmdp',
  invoking_callback_dismissFlow: 'invoking_callback_dismissFlow',
  invoking_callback_finishFlow: 'invoking_callback_finishFlow',
  invoking_callback_entitlementChanged: 'invoking_callback_entitlementChanged',
  invoking_callback_cancelButtonPressed:
    'invoking_callback_cancelButtonPressed',
  invoking_callback_phoneServicesAccountStatusChanged:
    'invoking_callback_phoneServicesAccountStatusChanged',
  invoking_callback_dataPlanAccountCancelled:
    'invoking_callback_dataPlanAccountCancelled',
  invoking_callback_dataPlanPendingRelease:
    'invoking_callback_dataPlanPendingRelease',
  invoking_callback_dataPlanAccountUpdatedWithInfo:
    'invoking_callback_dataPlanAccountUpdatedWithInfo',
  invoking_callback_dataPlanTransferAccountUpdatedWithInfo:
    'invoking_callback_dataPlanTransferAccountUpdatedWithInfo',
  invoking_callback_doneSelected: 'invoking_callback_doneSelected',
  invoking_callback_showVerifyingIndicator:
    'invoking_callback_showVerifyingIndicator',
  invoking_callback_hideVerifyingIndicator:
    'invoking_callback_hideVerifyingIndicator',
  invoking_callback_hideCancelButtonSelected:
    'invoking_callback_hideCancelButtonSelected',
  invoking_callback_showCancelButtonSelected:
    'invoking_callback_showCancelButtonSelected',
} as const;
